// extracted by mini-css-extract-plugin
export default {"wrapper":"Antagonist_wrapper__tMnwG"};